const Statement = () => {
  return (
    <section
      data-testid="statement-section"
      className="relative py-24 lg:py-36 overflow-hidden grain"
      style={{ backgroundColor: "#C7343D" }}
    >
      {/* decorative overlays */}
      <div
        className="absolute inset-0 opacity-30 pointer-events-none"
        style={{
          background:
            "radial-gradient(circle at 80% 20%, rgba(243,144,26,0.7), transparent 50%), radial-gradient(circle at 20% 80%, rgba(0,0,0,0.5), transparent 50%)",
        }}
      />

      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-12 text-white">
        <div className="flex items-center gap-4 mb-12">
          <div className="h-px w-12 bg-white/70" />
          <span className="text-xs font-semibold tracking-[0.3em] uppercase text-white/90">
            ¡Vamos a trabajar juntos!
          </span>
        </div>

        <blockquote
          data-testid="statement-quote"
          className="font-display text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-light tracking-[-0.02em] leading-[1.1] text-white text-balance max-w-5xl"
        >
          <span className="text-white/40 text-6xl lg:text-8xl leading-none font-extralight align-top">
            “
          </span>
          En Distribuidora Sacaru{" "}
          <span className="italic font-extralight">conectamos tus productos</span>{" "}
          con los mercados correctos; impulsamos tu alcance comercial con
          esquemas de distribución y consignación{" "}
          <span className="italic font-extralight">diseñados para ganar siempre</span>.
          Contáctanos y vamos a trabajar juntos.
          <span className="text-white/40 text-6xl lg:text-8xl leading-none font-extralight align-bottom">
            ”
          </span>
        </blockquote>
      </div>
    </section>
  );
};

export default Statement;
